import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "active": {
      "column": {
        "default": "1",
        "name": "active",
        "null": false,
        "type": "boolean"
      },
      "name": "active",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "evaluation_group_id": {
      "column": {
        "default": null,
        "name": "evaluation_group_id",
        "null": false,
        "type": null
      },
      "name": "evaluation_group_id",
      "selected_by_default": null,
      "translated": false
    },
    "liquid_rule": {
      "column": {
        "default": null,
        "name": "liquid_rule",
        "null": true,
        "type": "text"
      },
      "name": "liquid_rule",
      "selected_by_default": null,
      "translated": false
    },
    "position": {
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": false
    },
    "rule_type": {
      "column": {
        "default": null,
        "name": "rule_type",
        "null": false,
        "type": "string"
      },
      "name": "rule_type",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "EvaluationRule",
  "collectionKey": "evaluation_rules",
  "collectionName": "evaluation_rules",
  "i18nKey": "evaluation_rule",
  "camelizedLower": "evaluationRule",
  "name": "EvaluationRule",
  "nameDasherized": "evaluation-rule",
  "pluralName": "evaluation_rules",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "EvaluationRule::Translation",
      "collectionName": null,
      "foreignKey": "evaluation_rule_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "EvaluationGroup",
      "collectionName": "evaluation_groups",
      "foreignKey": "evaluation_group_id",
      "name": "evaluation_group",
      "macro": "belongs_to",
      "resource_name": "EvaluationGroup",
      "through": null
    },
    {
      "className": "EvaluationRule::Translation",
      "collectionName": null,
      "foreignKey": "evaluation_rule_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "active",
      "column": {
        "default": "1",
        "name": "active",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "evaluation_group_id",
      "column": {
        "default": null,
        "name": "evaluation_group_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "liquid_rule",
      "column": {
        "default": null,
        "name": "liquid_rule",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "position",
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "rule_type",
      "column": {
        "default": null,
        "name": "rule_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "EvaluationGroup",
      "collectionName": "evaluation_groups",
      "foreignKey": "evaluation_group_id",
      "name": "evaluation_group",
      "macro": "belongs_to",
      "resource_name": "EvaluationGroup",
      "through": null
    }
  ],
  "paramKey": "evaluation_rule",
  "primaryKey": "id"
}

/** Frontend model for EvaluationRule. */
class EvaluationRule extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  active() {
    return this.readAttributeUnderscore("active")
  }

  /** @returns {boolean} */
  hasActive() {
    const value = this.active()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  evaluationGroupId() {
    return this.readAttributeUnderscore("evaluation_group_id")
  }

  /** @returns {boolean} */
  hasEvaluationGroupId() {
    const value = this.evaluationGroupId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  liquidRule() {
    return this.readAttributeUnderscore("liquid_rule")
  }

  /** @returns {boolean} */
  hasLiquidRule() {
    const value = this.liquidRule()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {string} */
  ruleType() {
    return this.readAttributeUnderscore("rule_type")
  }

  /** @returns {boolean} */
  hasRuleType() {
    const value = this.ruleType()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  adminTest(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "admin_test",
        primaryKey: this.primaryKey(),
        collectionName: "evaluation_rules",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./evaluation-group.js").default | null} */
  evaluationGroup() {
    return this._readBelongsToReflection({reflectionName: "evaluation_group"})
  }

  /** @returns {Promise<import("./evaluation-group.js").default | null>} */
  loadEvaluationGroup() {
    if (!("evaluationGroupId" in this)) throw new Error("Foreign key method wasn't defined: evaluationGroupId")

    const id = this.evaluationGroupId()
    const modelClass = modelClassRequire("EvaluationGroup")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "evaluation_group", model: this, modelClass},
      {ransack}
    )
  }
}

export default EvaluationRule
